import Component from'./component';import EnhanceTabController from'./enhancers/EnhanceTabController';export default EnhanceTabController(Component);